import script from "./MST04_016INS.vue?vue&type=script&setup=true&lang=js"
export * from "./MST04_016INS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__